module.exports = __webpack_public_path__ + "static/media/ic_head9.61c25757.png";